/*
 * DRIPLABEL: keeps the swipe ticks in snippets/card-gallery-ticks.liquid in step
 * with Horizon's native product-card slideshow.
 *
 * Deliberately reads scrollLeft off <slideshow-slides> rather than listening for
 * the component's own slide events: the scroller is the single source of truth
 * during a drag, so the ticks track the finger instead of jumping only once the
 * snap has settled. It also means this file has no dependency on Horizon's
 * slideshow internals and cannot break when they change.
 *
 * One capture-phase listener on the document covers every card on the page,
 * including cards swapped in later by filtering, sorting or infinite scroll —
 * there is nothing to re-initialise after a section render.
 */
(function () {
  if (window.cgTicksReady) return;
  window.cgTicksReady = true;

  /* Slide width is cached per scroller. Reading clientWidth on every scroll
     event forces a layout, and a snap track fires a lot of them. */
  var widths = new WeakMap();

  function slideWidth(scroller) {
    var width = widths.get(scroller);
    if (!width) {
      width = scroller.clientWidth;
      if (width) widths.set(scroller, width);
    }
    return width;
  }

  window.addEventListener('resize', function () {
    widths = new WeakMap();
  });

  function paint(scroller) {
    var gallery = scroller.closest('.card-gallery');
    if (!gallery) return;

    var ticks = gallery.querySelector('[data-cg-ticks]');
    if (!ticks) return;

    var dots = ticks.children;
    if (!dots.length) return;

    var width = slideWidth(scroller);
    if (!width) return;

    var index = Math.round(Math.abs(scroller.scrollLeft) / width);
    if (index < 0) index = 0;
    if (index > dots.length - 1) index = dots.length - 1;

    if (scroller.cgTickIndex === index) return;
    scroller.cgTickIndex = index;

    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-on', i === index);
    }
  }

  /* Painted straight from the event rather than deferred through
     requestAnimationFrame: rAF is frozen in a background tab, which leaves the
     ticks stuck on the first pill, and only one card is ever under a finger so
     the work per event is a handful of class toggles against a cached width.
     Capture phase because scroll does not bubble. */
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (!target || !target.tagName) return;
      if (target.tagName.toLowerCase() !== 'slideshow-slides') return;
      paint(target);
    },
    true
  );
})();
